import { CanvaIcon, IconButton, Tooltip } from '@buffer-mono/popcorn'
import { Upload, UploadSource } from '@buffer-mono/uploader'
import type { Uploader } from '@buffer-mono/uploader'

import { useOpenCanva } from '~publish/legacy/canva/useOpenCanvaDesign'

import styles from './CanvaEditTag.module.css'

import type { JSX } from 'react'

export const CanvaEditTag = ({
  upload,
  uploader,
}: {
  upload: Upload
  uploader: Pick<Uploader, 'addFilesFromUrls'>
}): JSX.Element | null => {
  const source = Upload.getSource(upload)
  const designId = UploadSource.isCanva(source) ? source.id : undefined

  const openCanva = useOpenCanva({
    uploader,
    service: 'omni',
    designId,
  })

  if (!UploadSource.isCanva(source)) return null

  return (
    <Tooltip content="Edit Canva Design">
      {/* arrow fn so the mouse event is not forwarded as CanvaOpenOptions */}
      <IconButton
        className={styles.canvaTag}
        onClick={(): void => openCanva()}
        label="Edit Canva design"
        variant="tertiary"
      >
        <CanvaIcon />
      </IconButton>
    </Tooltip>
  )
}
